<template>
  <div class="right-association">
    <h1 v-if="title">{{title}}</h1>
    <p class="content-box" style="font-size: 16px; line-height: 22px;" v-html="context"></p>
  </div>
</template>

<script>
export default {
  props: ["context", "title"],
  data() {
    return {};
  },
  methods: {},
};
</script>
 
<style lang="less" scoped>
.right-association {
  box-sizing: border-box;
  padding: 31px 41px;
  > h1 {
    color: rgba(16, 16, 16, 1);
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 27px;
  }
  > p {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    line-height: 22px;
  }
}
</style>